import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMail, FiPhone, FiMapPin, FiInstagram, FiLinkedin, FiTwitter } = FiIcons;

const Footer = () => {
  const socialLinks = [
    { icon: FiInstagram, name: 'Instagram', url: '#' },
    { icon: FiLinkedin, name: 'LinkedIn', url: '#' },
    { icon: FiTwitter, name: 'Twitter', url: '#' }
  ];

  const services = ['Editing Naskah', 'Layout Jurnal', 'Desain Cover', 'Parafrase'];
  const quickLinks = [
    { name: 'Tentang Kami', path: '/about' },
    { name: 'Testimoni', path: '/testimoni' },
    { name: 'Kontak', path: '/kontak' },
    { name: 'Syarat & Ketentuan', path: '/syarat-ketentuan' }
  ];

  return (
    <footer className="bg-white border-t border-divider">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="space-y-6">
            <Link to="/" aria-label="Beranda Akademika Support" className="inline-block focus:outline-none focus:ring-2 focus:ring-primary rounded-lg">
              <img 
                src="https://acs.gedhemedia.com/AkademikaSupport_PrimaryLogoCrp.png" 
                alt="Logo Akademika Support" 
                className="h-10 w-auto" 
              />
            </Link>
            <p className="text-secondary font-medium leading-relaxed text-sm">
              Partner tepercaya bagi para akademisi Indonesia untuk menyelesaikan pekerjaan teknis penelitian secara profesional dan etis.
            </p>
            <div className="flex space-x-4">
              {socialLinks.map((social, idx) => (
                <a 
                  key={idx} 
                  href={social.url}
                  aria-label={`Kunjungi kami di ${social.name}`}
                  className="w-10 h-10 rounded-lg bg-primary/5 flex items-center justify-center text-primary hover:bg-primary hover:text-white transition-all border border-divider focus:outline-none focus:ring-2 focus:ring-primary"
                >
                  <SafeIcon icon={social.icon} className="w-5 h-5" aria-hidden="true" />
                </a>
              ))}
            </div>
          </div>

          {/* Services Column */}
          <div>
            <h4 className="text-primary font-bold mb-8 uppercase tracking-wider text-xs">Layanan</h4>
            <ul className="space-y-4">
              {services.map((item, idx) => (
                <li key={idx}>
                  <Link to="/layanan" className="text-secondary hover:text-primary transition-colors font-medium text-sm focus:outline-none focus:ring-2 focus:ring-primary rounded">
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links Column */}
          <div>
            <h4 className="text-primary font-bold mb-8 uppercase tracking-wider text-xs">Tautan Cepat</h4>
            <ul className="space-y-4 text-sm">
              {quickLinks.map((link, idx) => (
                <li key={idx}>
                  <Link to={link.path} className="text-secondary hover:text-primary transition-colors font-medium focus:outline-none focus:ring-2 focus:ring-primary rounded">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Column */}
          <div className="space-y-6">
            <h4 className="text-primary font-bold mb-8 uppercase tracking-wider text-xs">Hubungi Kami</h4>
            <div className="space-y-4 text-sm font-medium">
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiMail} className="text-primary shrink-0" aria-hidden="true" />
                <a href="mailto:halo@acadekasupport.id" className="text-secondary hover:text-primary transition-colors focus:outline-none focus:ring-2 focus:ring-primary rounded">
                  halo@akademikasupport.id
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiPhone} className="text-primary shrink-0" aria-hidden="true" />
                <a href="tel:+6281234567890" className="text-secondary hover:text-primary transition-colors focus:outline-none focus:ring-2 focus:ring-primary rounded">
                  +62 812-3456-7890
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiMapPin} className="text-primary shrink-0" aria-hidden="true" />
                <span className="text-secondary">Klaten, Indonesia</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Improved Copyright Bar with Deep Navy Background and Contrast Text */}
      <div className="py-8 bg-primary border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center text-center md:text-left gap-4">
          <p className="text-white/90 text-xs font-bold uppercase tracking-widest">
            © 2026 Academika Support. Semua Hak Cipta Dilindungi.
          </p>
          <div className="flex space-x-8">
            <Link to="/privacy-policy" className="text-white/80 hover:text-white transition-colors text-xs font-bold uppercase tracking-widest focus:outline-none focus:ring-2 focus:ring-white rounded px-1">
              Kebijakan Privasi
            </Link>
            <Link to="/syarat-ketentuan" className="text-white/80 hover:text-white transition-colors text-xs font-bold uppercase tracking-widest focus:outline-none focus:ring-2 focus:ring-white rounded px-1">
              Syarat & Ketentuan
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;